import * as THREE from 'three';

export default class LoadingScreen {
    constructor(resources, transition, teleports, cameraControls) {
        this.resources = resources
        this.transition = transition
        this.teleports = teleports
        this.placeholders = this.teleports.placeholders;
        this.cameraControls = cameraControls

        this.loadingScreen = document.getElementById('loading-screen')
        this.loadingScreen.classList.add('transitioning')

        this.isHome = false;

        if (this.resources.on('ready', () => {

            // Loading screen
            this.loadingScreen.classList.add('loaded-resources')
        }));

        // Does not get triggered on spawn.
        document.addEventListener("placeholderClicked", (event) => {
            this.loadingScreen.classList.remove('reached-location') // Remove because we are about to move
            this.loadingScreen.classList.add('transitioning') // Required for animating the opacity at the start of the loading screen
            this.addClasses()
        })

        this.setupEventListeners()
    }

    setupEventListeners(event) {
        for (const location of this.placeholders) {
            if (location.location) {
                const pathParts = window.location.pathname.split('/').filter(Boolean);
                let urlLocation = pathParts.length > 0 ? pathParts[pathParts.length - 1] : null;

                // if (location.id == urlLocation) {
                this.addClasses()
                // }

                // else if (urlLocation == null && !this.isHome) {
                //     this.isHome = true;
                //     this.addClasses()
                //     return
                // }
            }
        }
    }

    addClasses() {
        cameraControls.restTreshold = 0.2
        cameraControls.addEventListener('rest', (event) => {
            if (this.loadingScreen && !this.loadingScreen.classList.contains('loading-textures')) {
                this.loadingScreen.classList.remove('transitioning');
            }

            if (this.loadingScreen) {
                this.loadingScreen.classList.add('reached-location');
            }
        })
        cameraControls.addEventListener('sleep', (event) => {
            if (this.loadingScreen && !this.loadingScreen.classList.contains('loading-textures')) {
                this.loadingScreen.classList.remove('transitioning');
            }

            // If doens't move, reached-location which is true for all starting locations
            if (this.loadingScreen) {
                this.loadingScreen.classList.add('reached-location');
            }
        })
    }
}